import { render, staticRenderFns } from "./NPADocumentCard.vue?vue&type=template&id=f8bc3334&"
import script from "./NPADocumentCard.vue?vue&type=script&lang=js&"
export * from "./NPADocumentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports